/** Registration — always Luma */
export const LUMA_REGISTRATION_URL = "https://luma.com/v36q6jr4";

export const HACKATHON = {
    title: "Agentic Hack",
    titleTop: "Agentic",
    titleBottom: "Hack",
    titleSubtitleLead: "Agents and ",
    titleSubtitleAccent: "Robots",
    freeLabel: "Free",
    tagline:
        "12 hours to build real world payment agents.",
    buildBrief:
        "Two tracks, one hack: payments — agents and flows that move money on real rails (M-Pesa, cards, wallets, partner APIs like PayHero) — and robots — bots, autonomous systems, hardware, sensors, and anything in the IoT stack. Combine them or pick a lane; show a live demo that works.",
    dateLabel: "10 October 2026",
    dateIso: "2026-10-10",
    venueLabel: "Venue",
    venuePlace: "TBA, Nakuru, Kenya",
    /** @deprecated use venueLabel + venuePlace */
    location: "TBA, Nakuru, Kenya",
    host: "Build Bout",
    heroCardNote: "Limited seats",
    heroImage:
        "https://posthog-cyan.vercel.app/events/uoe-hackathon.png",
};

export const PRIZE_POOL = {
    headline: "~KES 100,000",
    subline: "in cash prizes across the podium and special awards",
    tiers: [
        {
            place: "Grand Prize",
            amount: "KES 40,000",
            detail: "Best end-to-end payments or robotics build with a live demo",
        },
        {
            place: "Runner-up",
            amount: "KES 30,000",
            detail: "Strong real-world use case and polished working prototype",
        },
        {
            place: "3rd Place",
            amount: "KES 20,000",
            detail: "Original idea with a working hardware or software integration",
        },
        {
            place: "Best Agentic Flow",
            amount: "KES 5,000",
            detail: "Clearest agent + payments or bot orchestration",
            accent: true,
        },
        {
            place: "Best Demo",
            amount: "KES 5,000",
            detail: "Most compelling live pitch and product story",
            accent: true,
        },
    ],
};

export const SCHEDULE_INTRO =
    "Pre activity: we restore degraded dryland together before hackathon day. On the main day: snacks on arrival, streamlined presentations and judging — build before you arrive, then come ready to demo payments, robots, or both.";

/** Pre activity runs before hackathon day (community restoration, not a second competition day). */
export const SCHEDULE_DAYS = [
    {
        id: "pre-activity",
        label: "Pre activity",
        tagline:
            "Community restoration before hackathon day — not a second competition day.",
        items: [
            {
                time: "Pre activity",
                title: "Reforest degraded dryland",
                detail:
                    "Hands-on planting at a selected dryland site. Help restore native cover, meet other builders, and give back before the main event.",
                accent: true,
            },
        ],
    },
    {
        id: "hackathon",
        label: "Day 1 — Hackathon day",
        tagline: "Presentations, judging, and prizes",
        items: [
            {
                time: "08:00",
                title: "Check-in",
                detail: "Snacks provided on arrival. Meet mentors and your team.",
            },
            {
                time: "08:30",
                title: "Kick-off & rules",
                detail: "Format, judging criteria, and payments & robots brief.",
            },
            {
                time: "09:00",
                title: "Streamlined presentations",
                detail: "Quick team intros and problem statements — no build sprint on site.",
            },
            {
                time: "10:00",
                title: "Judging begins",
                detail: "Early demos and evaluation start before lunch.",
            },
            {
                time: "13:00",
                title: "Lunch & progress",
                detail: "Refuel and share how far each project has come.",
            },
            {
                time: "15:00",
                title: "Final demos",
                detail: "Last pitches; judges finalize scores through the afternoon.",
            },
            {
                time: "18:00",
                title: "Winners announced",
                detail: "Prizes, photos, and closing on stage.",
            },
        ],
    },
];

/** @deprecated Use SCHEDULE_DAYS — kept for any legacy imports */
export const SCHEDULE = SCHEDULE_DAYS[1].items;

export const JUDGING = [
    "Does it work? Live payments, agent flow, robot, or IoT demo beats slides.",
    "Does it solve something real for Kenyan users or businesses?",
    "Is the payments + robots story clear and original?",
    "Could this product grow — market, compliance, reliability, and scale?",
    "Can you tell the story in 3 minutes?",
];

export const SPONSOR_TIERS = [
    {
        name: "Title sponsor",
        perks: [
            "Logo on stage, stream, and all comms",
            "Opening remarks slot (3 min)",
            "Judge seat + recruiting table",
        ],
    },
    {
        name: "Gold",
        perks: [
            "Logo on website & event materials",
            "Mentor office hours block",
            "Swag in participant kits",
        ],
    },
    {
        name: "Community partner",
        perks: [
            "Logo on website",
            "Shared social announcement",
            "In-kind perks for builders",
        ],
    },
];

/** Edit names/logos here; logos live in public/sponsors/ */
export const SPONSORS = [
    {
        name: "PayHero",
        tag: "Payments partner",
        logo: "/sponsors/payhero.png",
        url: "https://payhero.africa",
    },
    {
        name: "Nebo",
        tag: "Savings partner",
        logo: "/sponsors/nebo.png",
        logoOnDark: true,
        url: "https://nebo.co.ke/",
    },
    { name: "Build Bout", tag: "Host" },
    { name: "Your logo here", tag: "Sponsor slot" },
];

export const SPONSOR_CONTACT_EMAIL = "chidi@cheppar.co.ke";
export const HACKATHON_EVENTS_EMAIL = "events@cheppar.co.ke";

export const HACKATHON_FAQ = [
    {
        q: "Is Agentic Hack free To Attend?",
        a: "Yes! Food will be provided for the duration of the event. We will also have swag and prizes!",
    },
    {
        q: "Where is the event? Is it in person or virtual? Where can I park?",
        a: "The event will be in Nakuru, in person. The specific venue is still being discussed — we will share the location and parking details once it is confirmed.",
    },
    {
        q: "Who can attend? What if I don't have any experience? Do I have to be 18?",
        a: "This event is open to anyone. It is beginner friendly, with workshops to help you learn during the event, and mentors available to help you as you work on your project. Attendees must be at least 18 years old due to child privacy laws.",
    },
    {
        q: "What is the team size limit?",
        a: "Teams should be between 1 and 3 people. We will have a team-building activity right after the opening ceremony if you'd like to find teammates.",
    },
    {
        q: "Are there travel reimbursements?",
        a: "We are not able to provide travel reimbursements at this time.",
    },
    {
        q: "What should I bring?",
        a: "Your laptop, charger, headphones, deodorant, and a pillow/blanket.",
    },
    {
        q: "When can we start working on our project? Can I work on a previous project?",
        a: "The first line of code must be written after the opening ceremony. You may come up with ideas beforehand, but you are not allowed to start coding early. You cannot work on a previous project, but you may use frameworks if you clearly credit them in your readme and differentiate what you built vs. what you used.",
    },
    {
        q: "How many challenges can I apply for?",
        a: "A single track/challenge.",
    },
    {
        q: "Do I have to stay overnight?",
        a: "No — you can leave and come back later in the morning.",
    },
    {
        q: "What kind of activities will there be?",
        a: "We will post the schedule closer to the event. There will be workshops and activities to take a break, meet other hackers, and interact with our sponsors.",
    },
    {
        q: "What is a hackathon?",
        a: 'A hackathon is an event where builders "hack" together and create an app, website, game, robot, or agent in a short sprint. There will be no malicious "hacking".',
    },
    {
        q: "Will hardware be available?",
        a: "We do not have hardware available, but you are welcome to bring your own. Due to building fire codes, soldering kits are not allowed in the venue.",
    },
    {
        q: "Are you sending out acceptances? Is there a deadline to apply? Is there a waitlist?",
        a: "We will send out acceptances 30 days before the event. If you need earlier confirmation to book travel, please reach out to our team at chidi@cheppar.co.ke. Applications will close once we reach the maximum number of hackers we can support. We will open a waitlist a week before the event for local hackers who want to fill spots if accepted attendees cannot attend.",
    },
    {
        q: "How do I sign up to be a mentor/judge/volunteer?",
        a: "Register on Luma or email chidi@cheppar.co.ke — we will match you to a role.",
        mentorSignup: true,
    },
    {
        q: "I have a different question!",
        a: "Email us at events@cheppar.co.ke",
        eventsEmail: true,
    },
];
